<template>
  <div class="edit-user">
    <breadcrumbs />

    <div class="content">
      <rpw-user-form type="edit" v-on:edit="update"/>
      <rp-overlay :active="active">
        <rp-alert
          icon="done"
          :message="successMessage"
          :onClick="successFunction"
        >
        </rp-alert>
      </rp-overlay>
    </div>
  </div>
</template>

<script>
import UserForm from 'raypro_ui/src/components/ui/forms/User'
import Breadcrumbs from '@/components/Breadcrumbs'
import {updateUser} from 'raypro_ui/src/api/users'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Alert from 'raypro_ui/src/components/ui/Alert'
import page from '@/mixins/page'

export default {
  data() {
    return {
      active: false,
      successMessage: 'User updated successfully!',
      title: 'Edit User'
    }
  },

  components: {
    'rpw-user-form': UserForm,
    'rp-overlay': Overlay,
    'rp-alert': Alert,
    Breadcrumbs
  },

  mixins: [page],

  methods: {
    successFunction() {
      this.$router.push({name: 'view-surgeon', params: {id: this.data.id}})
    },

    update(data) {
      const payloadUser = {
        userUuid: this.$route.params.id,
        data: {user: data}
      }

      updateUser(payloadUser)
        .then(() => {
          this.active = true
        })
        .catch(({response}) => {
          this.errors = response
        })
    }
  }
}
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .edit-user
    .content
      @include media($media-large)
        display: flex

      .form-info
        flex-grow: 1
        flex-basis: 0
        margin-top: 30px

        @include media($media-large)
          max-width: 35rem
          margin-left: 0

        > span
          font-size: 1.4rem
          display: flex
          margin-bottom: 30px
          font-weight: $font-medium

          > span
            font-size: 2rem
            color: red
            font-weight: $font-regular
            margin-right: 1rem

        h4
          font-size: 1.4rem
          margin-bottom: 1.5rem
          font-weight: $font-medium

        p
          font-size: 1.4rem
          line-height: 2rem
          color: $color-side-nav
          font-weight: $font-regular
          margin-bottom: 1.5rem

        a
          cursor: pointer
          font-size: 1.4rem
          font-weight: $font-medium
          text-decoration: underline
</style>



// WEBPACK FOOTER //
// src/components/pages/Users/EditUser.vue